@use "@design/design-tokens/typography/typography" as *;
@use "@design/design-tokens/border-radius/border-radius" as *;

.root {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  flex-shrink: 0;
  padding: 4px 8px;
  gap: 4px;
  background: var(--surface-active);
  cursor: pointer;
  @include border-radius-r2;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 16px;

  &:hover {
    background: var(--surface-hover);
  }
}

.name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 360px;
  flex-shrink: 0;
}
